export default __webpack_public_path__ + "static/media/awards.b57fbc35.png";